"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _httpClient = _interopRequireDefault(require("@ceramicnetwork/http-client"));

var _idx = require("@ceramicstudio/idx");

var _idDidProvider = _interopRequireDefault(require("3id-did-provider"));

var _jsSha = require("js-sha256");

var _rpcUtils = require("rpc-utils");

var _store = _interopRequireDefault(require("store"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var _iframeService = _interopRequireDefault(require("./iframeService"));

var _errors = require("./errors");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CERAMIC_API = process.env.CERAMIC_API || 'https://ceramic-clay.3boxlabs.com';
var ACCOUNT_KEY = 'accounts';
var LINK_KEY = 'links';
var ACTIVE_ACCOUNT_KEY = 'active_account'; // TODO didprovider, auth failed codes?

var rpcError = function rpcError(id) {
  var rpcError = new _rpcUtils.RPCError(-32401, "3id-connect: Request not authorized");
  return Object.assign(rpcError.toObject(), {
    id: id
  });
};
/**
 *  ConnectService runs a 3ID DID provider instance and rpc server with
 *  bindings to receive and relay rpc messages to identity wallet
 */


var ConnectService = /*#__PURE__*/function (_IframeService) {
  (0, _inherits2["default"])(ConnectService, _IframeService);

  var _super = _createSuper(ConnectService);

  function ConnectService() {
    var _this;

    (0, _classCallCheck2["default"])(this, ConnectService);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "userRequestHandler", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancel", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "errorCb", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ceramic", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "threeId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "idx", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "provider", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "activeAccount", null);
    return _this;
  }

  (0, _createClass2["default"])(ConnectService, [{
    key: "start",

    /**
     *  Start connect service. Once returns ready to receive rpc requests
     *
     * @param     {Function}    userRequestHandler   Function to handle request for user (in user interface/modal)
     * @param     {Function}    errorCB              Function to handle errors, function consumes error string (err) => {...}, called on errors
     * @param     {Function}    cancel               Function to cancel request, consumes callback, which is called when request is cancelled (cb) => {...}
     */
    // @ts-ignore method override
    value: function start(userRequestHandler, errorCb, cancel) {
      this.cancel = cancel;
      this.errorCb = errorCb;
      this.userRequestHandler = userRequestHandler;
      this.ceramic = new _httpClient["default"](CERAMIC_API);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(ConnectService.prototype), "start", this).call(this, this.requestHandler.bind(this));
    } // Simplified Assumptions
    // always asks for authsecret if not available locally, ie two accounts linked, first one already auth, will not look up link for second to see if same did, will ask for an authsecret again
    // when account hasnt seen, two options, link to "active account" or create new,
    // linking means add auth method and public link right now, but can unbundle, code currently assumes in places
    // better manage state for race conditions, two window active
    // TODO handle link state better, stores links now, but does not sync with network before lookup

  }, {
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(accountId, authReq, domain) {
        var authSecret, accounts, accountAlreadyExist, firstAccount, otherAccountsExist, existInNetworkOnly, authId, authSecretAdd, defaultAccount, activeAccount, linkHuh;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _errors.assert.isDefined(this.userRequestHandler, 'User request handler must be defined');

                authSecret = this.getStoredAccount(accountId);
                accounts = this.getStoredAccountList();
                accountAlreadyExist = Boolean(authSecret);
                firstAccount = !accounts;
                otherAccountsExist = !authSecret && Boolean(accounts);

                if (accountAlreadyExist) {
                  _context.next = 12;
                  break;
                }

                _context.t0 = Boolean;
                _context.next = 10;
                return this._resolveLink(accountId);

              case 10:
                _context.t1 = _context.sent;
                existInNetworkOnly = (0, _context.t0)(_context.t1);

              case 12:
                authId = accountId;
                authSecretAdd = null;

                if (!(firstAccount || existInNetworkOnly)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return this.userPermissionRequest(authReq, domain);

              case 17:
                _context.next = 19;
                return this.authCreate(accountId);

              case 19:
                authSecret = _context.sent;

              case 20:
                if (!(otherAccountsExist && !authSecret)) {
                  _context.next = 38;
                  break;
                }

                // change request type, for now will link to "active account" (true) or create new, pass single account not array
                defaultAccount = accounts === null || accounts === void 0 ? void 0 : accounts[0];

                _errors.assert.isDefined(defaultAccount, 'A default account should be defined');

                activeAccount = this.getActiveAccount() || defaultAccount;
                _context.next = 26;
                return this.userRequestHandler({
                  type: 'account',
                  accounts: [activeAccount]
                });

              case 26:
                linkHuh = _context.sent;

                if (!linkHuh) {
                  _context.next = 35;
                  break;
                }

                authId = activeAccount;
                authSecret = this.getStoredAccount(authId);
                _context.next = 32;
                return this.authCreate(accountId);

              case 32:
                authSecretAdd = _context.sent;
                _context.next = 38;
                break;

              case 35:
                _context.next = 37;
                return this.authCreate(accountId);

              case 37:
                authSecret = _context.sent;

              case 38:
                _errors.assert.isDefined(authSecret, 'Auth secret should be defined to initialize identity');

                _context.next = 41;
                return this.initIdentity(authSecret, authId);

              case 41:
                if (!(otherAccountsExist && authSecretAdd)) {
                  _context.next = 44;
                  break;
                }

                _context.next = 44;
                return this.addAuth(accountId, authSecretAdd);

              case 44:
                if (!(firstAccount || authSecretAdd || accountAlreadyExist || !existInNetworkOnly)) {
                  _context.next = 47;
                  break;
                }

                _context.next = 47;
                return this.tryCreateLink(accountId);

              case 47:
                if (!(!firstAccount && !existInNetworkOnly)) {
                  _context.next = 50;
                  break;
                }

                _context.next = 50;
                return this.userPermissionRequest(authReq, domain);

              case 50:
                this.setActiveAccount(accountId);

              case 51:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x, _x2, _x3) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "initIdentity",
    value: function () {
      var _initIdentity = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(authSecret, authId) {
        var getPermission;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _errors.assert.isDefined(this.ceramic, 'Ceramic instance must be defined'); // Same request relayed before idw handles it, if request reaches idw, then permission given


                getPermission = function getPermission() {
                  return Promise.resolve([]);
                };

                _context2.next = 4;
                return _idDidProvider["default"].create({
                  getPermission: getPermission,
                  ceramic: this.ceramic,
                  authSecret: authSecret,
                  authId: authId
                });

              case 4:
                this.threeId = _context2.sent;
                this.provider = this.threeId.getDidProvider();
                _context2.next = 8;
                return this.ceramic.setDIDProvider(this.provider);

              case 8:
                this.idx = new _idx.IDX({
                  ceramic: this.ceramic
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initIdentity(_x4, _x5) {
        return _initIdentity.apply(this, arguments);
      }

      return initIdentity;
    }()
  }, {
    key: "tryCreateLink",
    value: function () {
      var _tryCreateLink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(accountId) {
        var links;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _errors.assert.isDefined(this.idx, 'IDX instance must be defined');

                _errors.assert.isDefined(this.threeId, 'ThreeIdProvider instance must be defined');

                _context3.next = 4;
                return this.idx.get('cryptoAccounts');

              case 4:
                links = _context3.sent;
                if (links) this.storeDIDLinks(this.threeId.id, Object.keys(links));

                if (links && links[accountId]) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 9;
                return this.createLinkDoc(accountId);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function tryCreateLink(_x6) {
        return _tryCreateLink.apply(this, arguments);
      }

      return tryCreateLink;
    }()
  }, {
    key: "addAuth",
    value: function () {
      var _addAuth = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(accountId, authSecretAdd) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _errors.assert.isDefined(this.threeId, 'ThreeIdProvider instance must be defined');

                _context4.next = 3;
                return this.threeId.keychain.add(accountId, authSecretAdd);

              case 3:
                _context4.next = 5;
                return this.threeId.keychain.commit();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addAuth(_x7, _x8) {
        return _addAuth.apply(this, arguments);
      }

      return addAuth;
    }()
  }, {
    key: "userPermissionRequest",
    value: function () {
      var _userPermissionRequest = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(authReq, domain) {
        var userReq, userPermission;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _errors.assert.isDefined(this.userRequestHandler, 'User request handler must be defined');

                userReq = this._createUserRequest(authReq, domain);

                if (userReq) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                if (!userReq) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 7;
                return this.userRequestHandler(userReq);

              case 7:
                _context5.t0 = _context5.sent;
                _context5.next = 11;
                break;

              case 10:
                _context5.t0 = null;

              case 11:
                userPermission = _context5.t0;

                if (userPermission) {
                  _context5.next = 14;
                  break;
                }

                throw new Error('3id-connect: Request not authorized');

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function userPermissionRequest(_x9, _x10) {
        return _userPermissionRequest.apply(this, arguments);
      }

      return userPermissionRequest;
    }()
  }, {
    key: "userPermissionRequest3id",
    value: function () {
      var _userPermissionRequest3id = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(req) {
        var userPersmission;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _errors.assert.isDefined(this.userRequestHandler, 'User request handler must be defined');

                if (!req) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 4;
                return this.userRequestHandler(req);

              case 4:
                _context6.t0 = _context6.sent;
                _context6.next = 8;
                break;

              case 7:
                _context6.t0 = null;

              case 8:
                userPersmission = _context6.t0;

                if (userPersmission) {
                  _context6.next = 11;
                  break;
                }

                throw new Error('3id-connect: Request not authorized');

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function userPermissionRequest3id(_x11) {
        return _userPermissionRequest3id.apply(this, arguments);
      }

      return userPermissionRequest3id;
    }()
    /**
     *  Creates an authSecret to add auth method 3ID
     */

  }, {
    key: "authCreate",
    value: function () {
      var _authCreate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(accountId) {
        var message, authSecret, entropy;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                message = 'Add this account as a Ceramic authentication method';
                _context7.next = 3;
                return this.authenticate(message);

              case 3:
                authSecret = _context7.sent;
                entropy = (0, _jsSha.sha256)(authSecret.slice(2));
                this.storeAccount(accountId, entropy);
                return _context7.abrupt("return", Uint8Array.from(Buffer.from(entropy, 'hex')));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function authCreate(_x12) {
        return _authCreate.apply(this, arguments);
      }

      return authCreate;
    }()
    /**
     *  Creates a publicly verifiable link between crypto account and 3id
     */

  }, {
    key: "createLinkDoc",
    value: function () {
      var _createLinkDoc = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(accountId) {
        var _yield$Promise$all, _yield$Promise$all2, linkProof, linkDoc, existingLinks, links;

        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _errors.assert.isDefined(this.ceramic, 'Ceramic instance must be defined');

                _errors.assert.isDefined(this.idx, 'IDX instance must be defined');

                _errors.assert.isDefined(this.threeId, 'ThreeIdProvider instance must be defined');

                _context8.next = 5;
                return Promise.all([this.createLink(this.threeId.id), this.ceramic.createDocument('caip10-link', {
                  metadata: {
                    controllers: [accountId]
                  }
                }, {
                  anchor: false,
                  publish: false
                })]);

              case 5:
                _yield$Promise$all = _context8.sent;
                _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2);
                linkProof = _yield$Promise$all2[0];
                linkDoc = _yield$Promise$all2[1];
                _context8.next = 11;
                return linkDoc.change({
                  content: linkProof
                });

              case 11:
                _context8.next = 13;
                return this.ceramic.pin.add(linkDoc.id);

              case 13:
                _context8.next = 15;
                return this.idx.get('cryptoAccounts');

              case 15:
                _context8.t0 = _context8.sent;

                if (_context8.t0) {
                  _context8.next = 18;
                  break;
                }

                _context8.t0 = {};

              case 18:
                existingLinks = _context8.t0;
                links = Object.assign(existingLinks, (0, _defineProperty2["default"])({}, accountId, linkDoc.id.toUrl()));
                _context8.next = 22;
                return this.idx.set('cryptoAccounts', links);

              case 22:
                this.storeDIDLinks(this.threeId.id, [accountId]);

              case 23:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function createLinkDoc(_x13) {
        return _createLinkDoc.apply(this, arguments);
      }

      return createLinkDoc;
    }()
  }, {
    key: "requestHandler",
    value: function () {
      var _requestHandler = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(message) {
        var _this2 = this;

        var domain, responsePromise;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                domain = new _urlParse["default"](document.referrer).host;
                responsePromise = new Promise(function (resolve, reject) {
                  // Register request cancel calback
                  _this2.cancel(function () {
                    return resolve(rpcError(message.id));
                  });

                  if (message.method.startsWith('did')) {
                    _this2.requestHandlerDid(message, domain).then(resolve, reject);
                  } else if (message.method.startsWith('3id')) {
                    // @ts-ignore compiler doesn't seem to properly handle type
                    _this2.requestHandler3id(message).then(resolve, reject);
                  } else {
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    var msg = "Unsupported method ".concat(message.method, ": only did_ and 3id_ methods are supported");
                    reject(new _errors.ConnectError(4, msg));
                  }
                });
                _context9.t0 = JSON;
                _context9.next = 5;
                return responsePromise;

              case 5:
                _context9.t1 = _context9.sent;
                return _context9.abrupt("return", _context9.t0.stringify.call(_context9.t0, _context9.t1));

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function requestHandler(_x14) {
        return _requestHandler.apply(this, arguments);
      }

      return requestHandler;
    }()
    /**
     *  Consumes DID RPC request message and relays to IDW didprovider instance. Also handles
     *  logic to retry requests and cancel requests.
     *
     * @param     {Object}      message    DID RPC request message
     * @return    {String}                 response message string
     */

  }, {
    key: "requestHandlerDid",
    value: function () {
      var _requestHandlerDid = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(message, domain) {
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(message.method === 'did_authenticate')) {
                  _context10.next = 6;
                  break;
                }

                _context10.next = 3;
                return this._didAuthReq(message, domain);

              case 3:
                _context10.t0 = _context10.sent;
                _context10.next = 9;
                break;

              case 6:
                _context10.next = 8;
                return this._relayDidReq(message, domain);

              case 8:
                _context10.t0 = _context10.sent;

              case 9:
                return _context10.abrupt("return", _context10.t0);

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function requestHandlerDid(_x15, _x16) {
        return _requestHandlerDid.apply(this, arguments);
      }

      return requestHandlerDid;
    }()
  }, {
    key: "requestHandler3id",
    value: function () {
      var _requestHandler3id = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(message) {
        var res;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                //TODO throw if not selfid or localhost
                res = null;

                if (!(message.method === '3id_accounts')) {
                  _context11.next = 7;
                  break;
                }

                _context11.next = 4;
                return this._listAccounts();

              case 4:
                res = _context11.sent;
                _context11.next = 20;
                break;

              case 7:
                if (!(message.method === '3id_createAccount')) {
                  _context11.next = 13;
                  break;
                }

                _context11.next = 10;
                return this._createAccount(message);

              case 10:
                res = _context11.sent;
                _context11.next = 20;
                break;

              case 13:
                if (!(message.method === '3id_addAuthAndLink')) {
                  _context11.next = 19;
                  break;
                }

                _context11.next = 16;
                return this._addAuthAndLink(message);

              case 16:
                res = _context11.sent;
                _context11.next = 20;
                break;

              case 19:
                throw new _errors.ConnectError(5, "Unsupported 3ID method: ".concat(message.method));

              case 20:
                _context11.next = 22;
                return this.hideIframe();

              case 22:
                return _context11.abrupt("return", res);

              case 23:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function requestHandler3id(_x17) {
        return _requestHandler3id.apply(this, arguments);
      }

      return requestHandler3id;
    }()
  }, {
    key: "_listAccounts",
    value: function _listAccounts() {
      // TODO ask user for permission in future
      var accounts = this.getDIDLinksList();
      return Promise.resolve({
        result: accounts
      });
    }
  }, {
    key: "_createAccount",
    value: function () {
      var _createAccount2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(message) {
        var accountId, authSecret;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _errors.assert.isDefined(message.params, 'Message parameters must be provided');

                accountId = message.params.accountId;
                _context12.next = 4;
                return this.userPermissionRequest3id({
                  type: 'create'
                });

              case 4:
                _context12.next = 6;
                return this.authCreate(accountId);

              case 6:
                authSecret = _context12.sent;
                _context12.next = 9;
                return this.initIdentity(authSecret, accountId);

              case 9:
                _context12.next = 11;
                return this.tryCreateLink(accountId);

              case 11:
                return _context12.abrupt("return", {
                  result: true
                });

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _createAccount(_x18) {
        return _createAccount2.apply(this, arguments);
      }

      return _createAccount;
    }() // TODO change name

  }, {
    key: "_addAuthAndLink",
    value: function () {
      var _addAuthAndLink2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(message) {
        var accountId, baseDid, req, authSecret, authSecretAdd;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _errors.assert.isDefined(message.params, 'Message parameters must be provided');

                accountId = message.params.accountId;
                baseDid = message.params.baseDid;
                req = {
                  type: 'link',
                  baseDid: baseDid,
                  accountId: accountId
                };
                _context13.next = 6;
                return this.userPermissionRequest3id(req);

              case 6:
                authSecret = this.getStoredAccountByDid(baseDid);
                _context13.next = 9;
                return this.authCreate(accountId);

              case 9:
                authSecretAdd = _context13.sent;
                _context13.next = 12;
                return this.initIdentity(authSecret, accountId);

              case 12:
                _context13.next = 14;
                return this.tryCreateLink(accountId);

              case 14:
                _context13.next = 16;
                return this.addAuth(accountId, authSecretAdd);

              case 16:
                return _context13.abrupt("return", {
                  result: true
                });

              case 17:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function _addAuthAndLink(_x19) {
        return _addAuthAndLink2.apply(this, arguments);
      }

      return _addAuthAndLink;
    }()
  }, {
    key: "_didAuthReq",
    value: function () {
      var _didAuthReq2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(message, domain) {
        var accountId, res;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _errors.assert.isDefined(this.errorCb, 'Error callback must be defined');

                _errors.assert.isDefined(message.params, 'Message parameters must be defined');

                _context14.prev = 2;
                accountId = message.params.accountId;

                if (!(this.activeAccount !== accountId)) {
                  _context14.next = 7;
                  break;
                }

                _context14.next = 7;
                return this.init(accountId, message, domain);

              case 7:
                _errors.assert.isDefined(this.provider, 'DID provider must be defined');

                _context14.next = 10;
                return this.provider.send(message, domain);

              case 10:
                res = _context14.sent;
                _context14.next = 13;
                return this.hideIframe();

              case 13:
                return _context14.abrupt("return", res);

              case 16:
                _context14.prev = 16;
                _context14.t0 = _context14["catch"](2);

                if (!_context14.t0.toString().includes('authorized')) {
                  _context14.next = 22;
                  break;
                }

                _context14.next = 21;
                return this.hideIframe();

              case 21:
                return _context14.abrupt("return", rpcError(message.id));

              case 22:
                this.errorCb(_context14.t0, 'Error: Unable to connect');

              case 23:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[2, 16]]);
      }));

      function _didAuthReq(_x20, _x21) {
        return _didAuthReq2.apply(this, arguments);
      }

      return _didAuthReq;
    }()
  }, {
    key: "_relayDidReq",
    value: function () {
      var _relayDidReq2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(message, domain) {
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _errors.assert.isDefined(this.provider, 'DID provider must be defined');

                _context15.next = 3;
                return this.provider.send(message, domain);

              case 3:
                return _context15.abrupt("return", _context15.sent);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function _relayDidReq(_x22, _x23) {
        return _relayDidReq2.apply(this, arguments);
      }

      return _relayDidReq;
    }()
    /**
     *  Looks up if accountId is linked to did
     */

  }, {
    key: "_resolveLink",
    value: function () {
      var _resolveLink2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(accountId) {
        var doc, linkDoc;
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _errors.assert.isDefined(this.ceramic, 'Ceramic instance must be defined');

                _context16.next = 3;
                return this.ceramic.createDocument('caip10-link', {
                  metadata: {
                    controllers: [accountId]
                  }
                }, {
                  anchor: false,
                  publish: false
                });

              case 3:
                doc = _context16.sent;
                _context16.next = 6;
                return this.ceramic.loadDocument(doc.id);

              case 6:
                linkDoc = _context16.sent;
                return _context16.abrupt("return", linkDoc.content);

              case 8:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function _resolveLink(_x24) {
        return _resolveLink2.apply(this, arguments);
      }

      return _resolveLink;
    }()
  }, {
    key: "storeAccount",
    value: function storeAccount(accountId, authSecretHex) {
      var accounts = this.getStoredAccounts();
      accounts[accountId] = authSecretHex;

      _store["default"].set(ACCOUNT_KEY, accounts);
    } // TODO any storage state should handle multiple windows, could cause problems here

  }, {
    key: "setActiveAccount",
    value: function setActiveAccount(accountId) {
      this.activeAccount = accountId;

      _store["default"].set(ACTIVE_ACCOUNT_KEY, accountId);
    }
  }, {
    key: "getActiveAccount",
    value: function getActiveAccount() {
      return _store["default"].get(ACTIVE_ACCOUNT_KEY);
    }
  }, {
    key: "getStoredAccount",
    value: function getStoredAccount(accountId) {
      var accounts = this.getStoredAccounts();
      return accounts[accountId] ? Uint8Array.from(Buffer.from(accounts[accountId], 'hex')) : null;
    }
  }, {
    key: "getStoredAccounts",
    value: function getStoredAccounts() {
      return _store["default"].get(ACCOUNT_KEY) || {};
    }
  }, {
    key: "getStoredAccountByDid",
    value: function getStoredAccountByDid(did) {
      var links = this.getDIDLinks(did) || [];
      var accounts = this.getStoredAccounts();
      var accountId = links.find(function (e) {
        return Boolean(accounts[e]);
      });

      _errors.assert.isString(accountId, 'Account does not exist');

      return Uint8Array.from(Buffer.from(accounts[accountId], 'hex'));
    }
  }, {
    key: "getStoredAccountList",
    value: function getStoredAccountList() {
      var val = _store["default"].get(ACCOUNT_KEY);

      return val ? Object.keys(val) : null;
    }
  }, {
    key: "storeDIDLinks",
    value: function storeDIDLinks(did) {
      var linkArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var dids = this.getDIDLinksList();
      var didsArr = dids[did] || [];
      var arr = didsArr.concat(linkArray.filter(function (i) {
        return didsArr.indexOf(i) < 0;
      }));
      dids[did] = arr;

      _store["default"].set(LINK_KEY, dids);
    }
  }, {
    key: "getDIDLinks",
    value: function getDIDLinks(did) {
      var dids = this.getDIDLinksList();
      return dids[did];
    }
  }, {
    key: "getDIDLinksList",
    value: function getDIDLinksList() {
      return _store["default"].get(LINK_KEY) || {};
    }
  }, {
    key: "getDIDs",
    value: function getDIDs() {
      var val = _store["default"].get(LINK_KEY);

      return val ? Object.keys(val) : null;
    }
  }, {
    key: "_createUserRequest",
    value: function _createUserRequest(req, origin) {
      _errors.assert.isDefined(req.params, 'Request parameters must be provided');

      if (this.threeId) {
        var has = req.params.paths ? this.threeId.permissions.has(origin, req.params.paths) : true;
        if (has) return null;
      }

      return {
        type: 'authenticate',
        origin: origin,
        paths: req.params.paths || []
      };
    }
  }]);
  return ConnectService;
}(_iframeService["default"]);

var _default = ConnectService;
exports["default"] = _default;